import type { ChangeEvent, ReactNode, RefObject } from "react";
// import { SignatureModal } from "../../../components/Form/SignatureModel";
// import { AttachmentSection } from "../../../components/Form/AttachmentSection";
import { DatalistInput } from "../components/dataListInput";
// import { FormActionButtons } from "../../../components/Form/FormActionButton";
import { useSettings } from "../../../context/SettingContext";
import type { LegalAdviceFormElevenData } from "../../../types/LegalAdvices/LegalAdviceFormEleven.type";


export interface AttachmentFile {
  name: string;
  [key: string]: any;
}

export interface DetailFormDocumentProps {
  formData: LegalAdviceFormElevenData;
  isEditable: boolean;
  isSigning: boolean;
  sigCanvasRef: RefObject<any>;
  setIsSigning: (isSigning: boolean) => void;
  handleChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleSaveSignature: () => void;
  renderDocumentRow: (label: string, fieldName: any) => ReactNode;
  renderDatePicker: (fieldName: any) => ReactNode;

  // Additional props required for action controls inside this component
  isPreview?: boolean;
  // isSubmitting?: boolean;
  // isApproved?: boolean;
  handleBackNavigation: () => void;
  // handleSaveDraft: (e: React.MouseEvent) => void;
  // handleSubmitToSuperior: (e: React.MouseEvent) => void;
 // handleAttachment:(e:React.MouseEvent)=> void;
}

export const LegalDetailFormElevenDocument: React.FC<DetailFormDocumentProps> = ({
  formData,
//   isSigning,
//   sigCanvasRef,
//   setIsSigning,
  handleChange,
//   handleSaveSignature,
//   renderDatePicker,
  // isApproved,
  // isSubmitting = false,
  // handleBackNavigation,
  // handleSaveDraft,
  // handleSubmitToSuperior,
  // handleAttachment
}) => {
  // Replace these with your actual option data sources or imports
 const { settings } = useSettings();

//  const isFormSigned = Boolean(
//     formData.signatureImage?.trim() && 
//     (formData.signerName?.trim() || formData.signName?.trim())
//   );

// Map to simple string arrays for your dropdowns/datalists
const OFFICE_OPTIONS = settings?.offices.map((o) => o.name) || [];
// const TOWNSHIP_OPTIONS = settings?.townships.map((t) => t.name) || [];


  return (
        <div className="w-full max-w-[850px] bg-white shadow-lg border border-gray-300 p-12 text-black space-y-12 text-xs md:text-sm leading-relaxed">
          
          {/* ခေါင်းစီးပိုင်း */}
          <div>
            <div className="text-right text-xs font-bold">ဥပရအမှုလိုက်ပုံစံ (၁၁)</div>
            
            <div className="text-center space-y-2 mt-2">
              <h1 className="text-base font-bold">ပြည်ထောင်စုသမ္မတမြန်မာနိုင်ငံတော်အစိုးရ</h1>
              <h2 className="text-sm font-bold">ပြည်ထောင်စုရှေ့နေချုပ်ရုံး</h2>
              
              <div className="flex justify-center items-center gap-2">
                <DatalistInput
                  name="office"
                  value={formData.office}
                  onChange={handleChange}
                  placeholder=""
                  options={OFFICE_OPTIONS}
                />
                <span className="font-bold">ဥပဒေရုံး</span>
              </div>
  
              {/* <div className="flex justify-center items-center pt-2">
                <span className="font-medium">ဥပဒေ မှတ်ပုံတင် (</span>
                <input type="text" name="lawRegisterNo" value={formData.lawRegisterNo} onChange={handleChange} className="w-16 bg-transparent border-b border-black text-center focus:outline-none font-bold" />
                <span className="font-medium">) စာမူတ်စဉ်</span>
              </div> */}
  
              <h3 className="text-sm font-bold pt-4 text-center">
                တရားမဇာရီမှု ပြီးပြတ်ချက်ပုံစံ
              </h3>
            </div>
  
            {/* အပိုင်း ၁။ ရုံးအချက်အလက်များ (၁ မှ ၁၃) */}
            <div className="mt-8 space-y-4">
              <div className="flex items-baseline">
                <span className="w-10 font-bold">၁။</span>
                <span className="w-64">တရားရုံးအမည်</span>
                <input type="text" name="courtName" value={formData.courtName} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none px-2" />
              </div>
  
              <div className="flex items-baseline">
                <span className="w-10 font-bold">၂။</span>
                <span className="w-64">တရားမ ဇာရီမှု အမှတ်</span>
                <input type="text" name="executionCaseNo" value={formData.executionCaseNo} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none px-2" />
              </div>
  
              <div className="flex items-baseline">
                <span className="w-10 font-bold">၃။</span>
                <span className="w-64">တရားနိုင်အမည်</span>
                <input type="text" name="decreeHolderName" value={formData.decreeHolderName} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none px-2" />
              </div>
  
              <div className="flex items-baseline">
                <span className="w-10 font-bold">၄။</span>
                <span className="w-64">တရားရှုံးအမည်</span>
                <input type="text" name="judgmentDebtorName" value={formData.judgmentDebtorName} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none px-2" />
              </div>
  
              <div className="flex items-baseline">
                <span className="w-10 font-bold">၅။</span>
                <span className="w-64">မည်သူ့အတွက် လိုက်ပါဆောင်ရွက်သည်</span>
                <input type="text" name="representedParty" value={formData.representedParty} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none px-2" />
              </div>
  
              <div className="flex flex-col space-y-1">
                <div className="flex items-baseline">
                  <span className="w-10 font-bold">၆။</span>
                  <span className="flex-1">တရားမ မူလမှု အမှတ်နှင့် စီရင်ချက်၊ အမိန့်၊ ဒီကရီချမှတ်သည့် ရက်စွဲ (စီရင်ချက်၊ အမိန့်နှင့် ဒီကရီပူးတွဲထားပါသည်)</span>
                </div>
                <textarea name="originalCaseDetails" value={formData.originalCaseDetails} onChange={handleChange} rows={3} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none mt-1" />
              </div>
  
              <div className="flex items-baseline gap-4">
                <div className="flex items-baseline">
                  <span className="w-10 font-bold">၇။</span>
                  <span className="w-80">အဆင့်မြင့်တရားရုံးသို့ အယူခံမှု၊ ပြင်ဆင်မှု၊ အထွေထွေလျှောက်ထားမှု ဝင်ရောက်ခဲ့ခြင်း ရှိ/မရှိ</span>
                </div>
                <select name="higherCourtAppealStatus" value={formData.higherCourtAppealStatus} 
                // onChange={handleChange}
                 className="bg-transparent border-b border-black focus:outline-none font-bold py-0.5">
                  <option value="ရှိ">ရှိ</option>
                  <option value="မရှိ">မရှိ</option>
                </select>
              </div>
  
              <div className="flex flex-col space-y-1">
                <div className="flex items-baseline">
                  <span className="w-10 font-bold">၈။</span>
                  <span className="flex-1">အဆင့်မြင့် တရားရုံး၏ အယူခံမှု၊ ပြင်ဆင်မှု၏ စီရင်ချက်အမိန့်၊ အတည်နှင့် ရက်စွဲ</span>
                </div>
                <textarea name="higherCourtDecreeDetails" value={formData.higherCourtDecreeDetails} onChange={handleChange} rows={3} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none mt-1" />
              </div>
  
              <div className="flex items-baseline">
                <span className="w-10 font-bold">၉။</span>
                <span className="w-64">ဇာရီလျှောက်လွှာတင်သွင်းသည့်ရက်စွဲ</span>
                <input type="text" name="executionApplicationDate" value={formData.executionApplicationDate} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none px-2" />
              </div>
  
              <div className="flex items-baseline gap-4">
                <div className="flex items-baseline">
                  <span className="w-10 font-bold">၁၀။</span>
                  <span className="w-64">တရားရှုံးမှ ကန့်ကွက်ခြင်း ရှိ/မရှိ</span>
                </div>
                <select name="courtObjectionStatus" value={formData.courtObjectionStatus} 
                // onChange={handleChange} 
                className="bg-transparent border-b border-black focus:outline-none font-bold py-0.5">
                  <option value="ရှိ">ရှိ</option>
                  <option value="မရှိ">မရှိ</option>
                </select>
              </div>
  
              <div className="flex flex-col space-y-1">
                <div className="flex items-baseline">
                  <span className="w-10 font-bold">၁၁။</span>
                  <span className="flex-1">ကန့်ကွက်လွှာတင်သည့် ရက်စွဲနှင့် အကြောင်းပြချက်အကျဉ်း</span>
                </div>
                <textarea name="objectionDetails" value={formData.objectionDetails} onChange={handleChange} rows={3} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none mt-1" />
              </div>
  
              <div className="flex items-baseline gap-4">
                <div className="flex items-baseline">
                  <span className="w-10 font-bold">၁၂။</span>
                  <span className="w-64">ပုဂ္ဂလိက ဒီကရီလျှောက်ထားမှု ရှိ/မရှိ (ရှိလျှင်ဖော်ပြရန်)</span>
                </div>
                <select name="priorDecreeApplicationStatus" value={formData.priorDecreeApplicationStatus} 
                // onChange={handleChange} 
                className="bg-transparent border-b border-black focus:outline-none font-bold py-0.5">
                  <option value="ရှိ">ရှိ</option>
                  <option value="မရှိ">မရှိ</option>
                </select>
              </div>
  
              <div className="flex flex-col space-y-1">
                <div className="flex items-baseline">
                  <span className="w-10 font-bold">၁၃။</span>
                  <span className="flex-1">ဇာရီမှု ပိတ်သည့်ရက်စွဲနှင့် ပိတ်ရသည့် အကြောင်းပြချက်</span>
                </div>
                <textarea name="executionClosedDetails" value={formData.executionClosedDetails} onChange={handleChange} rows={3} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none mt-1" />
              </div>

              <div className="flex flex-col space-y-1">
              <div className="flex items-baseline">
                <span className="w-10 font-bold">၁၄။</span>
                <span className="flex-1">ဇာရီမှုတွင် ချမှတ်သည့် အမိန့်အကျဉ်းနှင့်ရက်စွဲ</span>
              </div>
              <textarea name="executionOrderDetails" value={formData.executionOrderDetails} onChange={handleChange} rows={3} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none mt-1" />
            </div>
            </div>
          </div>
  
          <hr className="border-gray-300" />
  
          {/*အမှုလိုက် ဥပဒေအရာရှိ၏ သဘောထားမှတ်ချက် (၁၅) */}
          <div className="space-y-4">
            <div className="flex flex-col space-y-1">
              <label className="font-bold"><span className="mr-4">၁၅။</span>အမှုလိုက် ဥပဒေအရာရှိ၏ သဘောထားမှတ်ချက်</label>
              <textarea name="handlingOfficerOpinion" value={formData.handlingOfficerOpinion} onChange={handleChange} rows={4} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none mt-1" />
            </div>
  
            <div className="flex flex-col items-end pt-2">
              <div className="w-64 space-y-2">
                <div className="flex items-center">
                  <span className="w-24 text-right text-xs mr-2">လက်မှတ်</span>
                  <div 
                //   onClick={() => handleOpenSignatureModal('handling')} 
                  className="flex-1 bg-transparent border-b border-dotted border-black min-h-[32px] flex items-center justify-center cursor-pointer hover:bg-gray-50 relative">
                    {formData.handlingOfficerSignature ? (
                      <img src={formData.handlingOfficerSignature} alt="Handling Sign" className="h-8 object-contain" />
                    ) : (
                      <span className="text-gray-400 text-xs">✍️ လက်မှတ်ထိုးရန်</span>
                    )}
                    {formData.prosecutorSignatureImage && (
                      <button
                        type="button"
                        // onClick={handleClearHandlingSignature}
                        title="လက်မှတ်ရှင်းလင်းမည်"
                        className="absolute -right-6 text-slate-400 hover:text-rose-500 text-xs px-1 font-bold z-10 print:hidden"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                </div>
                <div className="flex items-center">
                  <span className="w-24 text-right text-xs mr-2">အမည်</span>
                  <input type="text" name="handlingOfficerName" value={formData.handlingOfficerName} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" />
                </div>
                <div className="text-center text-xs font-bold pt-1">အမှုလိုက်ဥပဒေအရာရှိ</div>
                <div className="flex items-center">
                  <span className="w-32 shrink-0 whitespace-nowrap text-right text-xs mr-2">တင်ပြသည့်ရက်စွဲ</span>
                  <input type="text" name="handlingOfficerSubmitDate" value={formData.handlingOfficerSubmitDate} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" />
                </div>
              </div>
            </div>
          </div>
  
          <hr className="border-gray-300" />
  
          {/*တာဝန်ခံ ဥပဒေအရာရှိ၏ သဘောထားမှတ်ချက် (၁၆) */}
          <div className="space-y-4">
            <div className="flex flex-col space-y-1">
              <label className="font-bold"><span className="mr-4">၁၆။</span>တာဝန်ခံ ဥပဒေအရာရှိ၏ သဘောထားမှတ်ချက်</label>
              <textarea name="inChargeOfficerOpinion" value={formData.inChargeOfficerOpinion} onChange={handleChange} rows={4} className="w-full bg-transparent border border-gray-300 rounded p-2 focus:outline-none mt-1" />
            </div>
  
            <div className="flex flex-col items-end pt-2">
              <div className="w-64 space-y-2">
                <div className="flex items-center">
                  <span className="w-24 text-right text-xs mr-2">လက်မှတ်</span>
                  <div
                //    onClick={() => handleOpenSignatureModal('incharge')} 
                   className="flex-1 bg-transparent border-b border-dotted border-black min-h-[32px] flex items-center justify-center cursor-pointer hover:bg-gray-50 relative">
                    {formData.inChargeOfficerSignature ? (
                      <img src={formData.inChargeOfficerSignature} alt="In-charge Sign" className="h-8 object-contain" />
                    ) : (
                      <span className="text-gray-400 text-xs">✍️ လက်မှတ်ထိုးရန်</span>
                    )}
                    {formData.prosecutorSignatureImage && (
                      <button
                        type="button"
                        // onClick={handleClearInChargeOfficerSignature}
                        title="လက်မှတ်ရှင်းလင်းမည်"
                        className="absolute -right-6 text-slate-400 hover:text-rose-500 text-xs px-1 font-bold z-10 print:hidden"
                      >
                        ✕
                      </button>
                    )}
                  </div>
                </div>
                <div className="flex items-center">
                  <span className="w-24 text-right text-xs mr-2">အမည်</span>
                  <input type="text" name="inChargeOfficerName" value={formData.inChargeOfficerName} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" />
                </div>
                <div className="text-center text-xs font-bold pt-1">တာဝန်ခံဥပဒေအရာရှိ</div>
                <div className="flex items-center">
                  <span className="w-32 shrink-0 whitespace-nowrap text-right text-xs mr-2">တင်ပြသည့်ရက်စွဲ</span>
                  <input type="text" name="inChargeOfficerSubmitDate" value={formData.inChargeOfficerSubmitDate} onChange={handleChange} className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center" />
                </div>
              </div>
            </div>
          </div>

          {/* Attachment Section */}
          
        </div>
  );
};